import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import DatePickerInput from '@components/common/input/DatePickerInput';
import { DatePickerFieldType } from '@/type';

interface DatePickerFieldProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  textField: DatePickerFieldType;
  disabled: boolean;
}

const DatePickerFieldController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  textField,
  disabled = false,
}: DatePickerFieldProps<TFieldValues>) => {
  return (
    <Controller
      name={textField.name as any}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePickerInput
          field={field}
          dateField={textField}
          error={!!error}
          helperText={error ? error.message : ''}
          disabled={disabled}
        />
      )}
    />
  );
};

export default DatePickerFieldController;
